import React, { useState } from "react";
import { FaComments } from "react-icons/fa";
import MainPageDialog from "../../../../components/mainPageDialog";

const CareplanGoals = ({ listData = [], loading = false }) => {
  const [commentsDialog, setCommentsDialog] = useState(false);
  const [commentsText, setCommentsText] = useState("");

  if (loading) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white px-4 py-8 text-center text-sm text-gray-500 shadow-sm mt-3">
        Loading...
      </div>
    );
  }

  return (
    <>
      {listData?.map((v) => (
          <div key={v?.type} className="py-2">
            <div className="flex flex-col">
              <p className="text-xl font-bold py-5">{v?.type}</p>
              <div className="">
                <div className="flex-shrink-0"></div>
                <div className="min-w-0 flex gap-x-5">
                  {v?.goal?.map((val) => (
                    <div key={val?.id} className="relative w-96 flex flex-col space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400">
                      <p className="text-sm font-medium text-center text-gray-900">
                        {val?.goals}
                      </p>
                      <div className="pt-5 flex flex-row gap-x-2">
                        <strong>Progress:</strong>
                        <div
                          className="flex w-full h-4 mt-1 bg-gray-200 rounded-full overflow-hidden dark:bg-neutral-700"
                          role="progressbar"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div
                            className={`flex flex-col justify-center rounded-full overflow-hidden  ${
                              val?.completed === 0
                                ? "bg-gray-200"
                                : "bg-blue-600"
                            } text-xs ${
                              val?.completed === 0
                                ? "text-blue-500"
                                : "text-white"
                            } text-center whitespace-nowrap dark:bg-blue-500 transition duration-500`}
                            style={{
                              width:
                                val?.completed !== 0
                                  ? val?.completed + "%"
                                  : "10%",
                            }}
                          >
                            {" "}
                            {val?.completed}%
                          </div>
                        </div>
                      </div>
                      {val?.progress_comments !== "" && (
                        <div className="flex justify-end items-end pt-8 text-sm">
                          <span>Latest Comments by care team:</span>
                          <span
                            onClick={() => {
                              setCommentsDialog(true);
                              setCommentsText(val?.progress_comments);
                            }}
                            className="text-green-500 text-lg hover:text-green-900 ml-1"
                          >
                            <FaComments />
                          </span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      {commentsDialog && (
        <MainPageDialog
          title="Comments"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => setCommentsDialog(null),
            },
          ]}
          onCancelHandler={() => setCommentsDialog(null)}
        >
          {commentsText === "" ? "No comments added." : commentsText}
        </MainPageDialog>
      )}
    </>
  );
};

export default CareplanGoals;
